import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addCartOrderRes;
export const addCartOrderTodo = createAsyncThunk('addCartOrder', async (data) => {
    // console.log("datasunmit", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'added_and_updated',
            data: { data },
            headers: { "Content-Type": "application/json" }
        })
        return addCartOrderRes = res.data

    } catch (error) {
        return addCartOrderRes = error.response.data
    }
})